const ChatActionType = {
    "CHAT_IN": "CHAT_IN",
    "CHAT_OUT": "CHAT_OUT",
    "INITIATE_RETRY": "INITIATE_RETRY",
    "INITIATE": "INITIATE",
    "SHOW_DFF_FORM": "SHOW_DFF_FORM",
    "SHOW_DFF_RESPONSE": "SHOW_DFF_RESPONSE",
    "SHOW_DFF_CRM_ERROR": "SHOW_DFF_CRM_ERROR",
    "ASK_FOR_LOGIN": "ASK_FOR_LOGIN",
    "NO_INTENT_FOUND": "NO_INTENT_FOUND",
    "SHOW_RESPONSE": "SHOW_RESPONSE",
    "USER_RESPONSE": "USER_RESPONSE",
    "FEEDBACK_ACTION": "FEEDBACK_ACTION",
    "BOOKMARK": "BOOKMARK",
    "CHOICE_OPTION_LINK": "CHOICE_OPTION_LINK",
    "SHOW_WELCOME_COMP": "SHOW_WELCOME_COMP",
    "CREATE_SR": "CREATE_SR",
    "COUNTRY_SELECT": "COUNTRY_SELECT",
    "NO_ACTION_CHOSEN" :"NO_ACTION_CHOSEN"
}

export default ChatActionType;


// WEBPACK FOOTER //
// ./src/enums/action-types/ChatActionType.js